// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__5VMD1","actionsWrapper":"styles_actionsWrapper__QQ42G","content":"styles_content__3r3xt"};